var map = {
	"./zhg_icon_01.png": "e57a",
	"./zhg_icon_02.png": "a92f",
	"./zhg_icon_03.png": "e46c",
	"./zhg_icon_04.png": "ec80",
	"./zhg_icon_05.png": "316c",
	"./zhg_icon_06.png": "b0de"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7e6d";